
export enum CheckState {
    CHECKED,
    UNCHECKED,
    PARTIALLY_CHECKED
}

export class TreeNodeLeafChild {
    public id: string = "";
    public label: string = "";
    public is_checked: boolean = true;
    public parent: number = -1;
    public superParent: number = -1;
}

export class TreeNodeChild {
    public id: string = "";
    public label: string = "";
    public checked_state: CheckState = CheckState.CHECKED;
    public is_expanded: boolean = false;
    public parent: number = -1;
    public children: TreeNodeLeafChild[] = []
}

export class TreeNodeParent {
    public id: string = "";
    public label: string = "";
    public checked_state: CheckState = CheckState.CHECKED;
    public is_expanded: boolean = true;
    public children: TreeNodeChild[] = [];
}


// WEBPACK FOOTER //
// ./src/models/TreeNode.ts